// the address photo (tasks#227): read as the media object, written as its IRI; null removes it
export function mediaIri(image) {
    if (!image) return null
    if (typeof image === 'string') return image
    return image['@id'] || null
}
